import { GET_CATEGORIES } from 'common/lib/graphQl/categories';
import client from 'lib/graphQl/ApolloClient';

export const getCachedCategory = (categoryId: Maybe<string>) => {
  const cachedData = client.cache.readQuery({ query: GET_CATEGORIES });
  return categoryId ? cachedData?.categories?.find(({ id }) => id === categoryId) : undefined;
};
